module.exports = "pegasus_template/assets/themelp1/coming_soon/101.png";